import React from "react";
import EmptyState from "../../../component/emptyState/EmptyState";

const InstitutionScopeEmpty = ({ title, description }) => (
  <EmptyState title={title} description={description} variant="bordered" />
);

export default InstitutionScopeEmpty;
